const theme = {
  colors: {
    main: '#3D385F',
    secondary: '#414767',
    darker: '#231123',
    cta: '#D64045',
    cta2: '#ba3035',
    error: '#f1d1d1',
    info: '#d1ecf1',
    warn: '#f1f0d1',
    msuccess: '#d1f1d4',
    text: '#EFEFEF',
    success: '#68A691',
    blue: '#4287f5',
    darkerBlue: '#27549c',
    hoverSuccess: '#5f9684',
    darkSuccess: '#508070',
    darkText: '#212529',
    border: '#f6f5fa',
    pronouncedBorder: '#ced4da',
    textField: '#fff',
    darkWhite: '#808080',
    deepBlue: '#020b2d',
    darkButton: 'rgba(0, 0, 0, 0)',
    shadow: 'rgba(33, 33, 33, 0.2)',
    badge: '#414767',
    card: '#fff',
    gray: '#e4ebec',

    dark: {
      main: '#1E1E1E',
      secondary: '#282828',
      darker: '#231123',
      cta: '#FE4A49',
      cta2: '#ba3035',
      error: '#db8484',
      info: '#9fe1ed',
      warn: '#ebe898',
      msuccess: '#7fdb88',
      blue: '#326dc9',
      darkerBlue: '#27549c',
      text: '#EFEFEF',
      success: '#68A691',
      hoverSuccess: '#5f9684',
      darkSuccess: '#508070',
      darkText: '#EAEAEA',
      border: '#292828',
      pronouncedBorder: '#353535',
      textField: '#282828',
      darkWhite: '#808080',
      deepBlue: '#1A1A1A',
      darkButton: '#1c1c1c',
      shadow: 'rgba(212, 212, 212, 0.3)',
      badge: '#3700B3',
      card: '#1A1A1A',
      gray: '#353535',
    },
  },

  fonts: {
    Ubuntu: "'Ubuntu Mono', monospace",
    VT323: "'VT323', monospace",
  },
};

export default theme;
